<template>
    <div v-if="errorsMessagesFromApi && errorsMessagesFromApi.length" class="alert alert-danger" role="alert">
        <div v-for="message in errorsMessagesFromApi">
            {{ message }}
        </div>
    </div>
</template>
<script>

    import {mapFields} from "vuex-map-fields";

    export default {
        name    : 'error-messages',
        props   : {
            field: String
        },
        data() {
            return {};
        },
        methods : {},
        computed: {
            ...mapFields([
                'errorsMessagesFromApi',
            ]),
            isValid() {
                return true;
            },
        },
        mounted() {
        },
    }
</script>
